<template>
	<v-dialog v-model="dialog" max-width="500px">
		<template v-slot:activator="{ on }">
			<v-btn @click="defaultService" color="primary" dark class="mb-2 ml-2" v-on="on">New Group</v-btn>
		</template>
		<v-card >
			<v-container fluid>
				<v-card-title>
					<span class="headline"> Add Group </span>
				</v-card-title>

				<v-row>
					<v-col cols="6" sm="6" md="4">
						<v-combobox 
						class="text-capitalize"
						:items="services"
						v-model="group.service"
						label="Service"
						placeholder="Or Create New"
						:disabled="!$store.state.user.admin"
						>
					</v-combobox>
				</v-col>

				<v-col cols="6" sm="6" md="4">
					<v-combobox
					text-capitalize 
					:items="groups"
					placeholder="Or Create New"
					v-model="group.name" label="Group"
					>
				</v-combobox>
			</v-col>

		</v-row>

		<v-card-text>
			<v-row>
				<v-col cols="12" class="py-0">
					<template>
						<v-sheet
						v-if="!group.imageUrl"
						color="darken-2"
						class="px-3 pt-3 pb-3"
						>
						<v-skeleton-loader
						class="mx-auto"
						max-width="300"
						type="image"
						boilerplate
						></v-skeleton-loader>
					</v-sheet>
				</template>
				<v-img mb-6 v-if="group.imageUrl" :src="group.imageUrl" height="300" class="image" contain></v-img>
			</v-col>

			<v-col cols="12" v-if="uploader" class="">
				Upload Progress:
				<v-progress-linear
				:value="uploader"
				height="25"
				reactive
				readonly
				>
				<strong>{{ Math.ceil(uploader) }}%</strong>
			</v-progress-linear>
		</v-col>
	</v-row>
</v-card-text>

<v-card-actions>
	<v-btn class="primary text-right float-right" @click="onPickFile" >Select Image</v-btn>
	<input
	type="file"
	style="display: none;"
	ref="fileInput"
	accept="image/*"
	@change="onFilePicked"
	>
	<v-spacer></v-spacer>
	<v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
	<v-btn color="blue darken-1" text @click="save" >Save</v-btn>
</v-card-actions>
</v-container>
</v-card>
</v-dialog>
</template>

<script>
	import firebase from '@/helpers/firebaseConfig'
	const db = firebase.firestore()
	export default {
		data: () => ({
			dialog: false,
			files: [],
			uploader: null,
			defaultItem: {
				name: '',
				service: '',
				imageUrl: undefined,
				id: '',
			},
			group: {
				name: '',
				service: '',
				imageUrl: undefined,
				id: '',
			},
		}),

		computed: {
			cId () {
				return this.$store.getters.user.cId
			},
			pricebook () {
				return this.$store.getters.pricebook
			},
			services () {
				return this.$store.getters.services
			},
			groups () {
				return this.$store.getters.groups.map(v=>v.name)
			}
		},
		methods: {
			defaultService(){
				if (!this.$store.state.user.admin){
					this.group.service = this.$store.state.user.service
				}
			},
			save() {
				if (this.group.imageUrl == '' || this.group.name == '' || this.group.service == ''){
					return this.$store.commit('setSnack', 'Title And Image Are Required')
				}
				let file = this.files[0]
				let storageRef = firebase.storage().ref(`${this.cId}/${this.group.service}/groups/${this.files[0].name}`)
				let task = storageRef.put(file)
				let _this = this
				task.on('state_changed',
					// progress 
					(snapshot) => {
						console.log('snapshot ', snapshot)
						let percentage = ( snapshot.bytesTransferred / 
							snapshot.totalBytes) * 100
						this.uploader = percentage
					},
					// error
					(err) => {
						this.$store.commit('setSnack', 'Couldn\'t Save')
					},
					// complete
					() => {
						task.snapshot.ref.getDownloadURL().then(function(downloadURL) {
							console.log('File available at', downloadURL)
							_this.group.imageUrl = downloadURL
							db.collection('groups').add({..._this.group, cId: _this.$store.getters.user.cId, created: _this.$store.state.user.id})
							.then(()=>{
								_this.$store.commit('setSnack', 'Image Saved!')
								_this.close()
							})
							.catch(err=> _this.$store.commit('setSnack', 'Couldn\'t Save'))
						})

					})
			},
			close(){
				setTimeout(() => {
					this.files = new Array()
					this.dialog = false
					this.uploader = null
					this.group = new Object()
					this.group = this.defaultItem
				}, 300)
			},
			onPickFile (event) {
				this.$refs.fileInput.click()
			},
			onFilePicked (event) {
				this.files = event.target.files
				let filename = this.files[0].name
				if (filename.lastIndexOf('.') <= 0) {
					return alert('Please add a valid file!')
				}
				const fileReader = new FileReader()
				fileReader.addEventListener('load', () => {
					this.group.imageUrl = fileReader.result
				})
				fileReader.readAsDataURL(this.files[0])
			},
		} 
	}

</script>
<style scoped>
	* {
		/*border: 1px solid red !important;*/
	}
	.image {
		display: block;
		height: 300px;
		width: 300px;
		margin: 0 auto;
		position: relative !important;
	}
</style>






